<template>
  <div v-if="computedList">
    <section-header
      id="messages"
      :departmentId="departmentId"
      :swiftMove="swiftMove"
    >
      Messages (
      <span v-if="computedUnreplied > 0">{{ computedUnreplied }} /</span>
      {{ computedCount }})
    </section-header>
    <a :href="downloadLink" target="_blank">download</a>
    <div
      v-for="message in computedList"
      :key="message.id"
      :class="`messageBox ${message.client ? 'messageLeft' : 'messageRight'}`"
    >
      <div
        v-if="message.client && !message.dealt"
        :class="`messageUnread ${
          message.client ? 'messageLeftStatus' : 'messageRightStatus'
        }`"
      >
        Unreplied
      </div>
      <div
        v-if="!message.client && !message.dealt"
        :class="`messageUnread ${
          message.client ? 'messageLeftStatus' : 'messageRightStatus'
        }`"
      >
        Unread
      </div>
      <div
        v-if="message.client && message.dealt"
        :class="`messageRead ${
          message.client ? 'messageLeftStatus' : 'messageRightStatus'
        }`"
      >
        <EntityZ :entity="message.who" format="system" v-if="message.who" />
        replied {{ message.dealt | formatDateTime }}
      </div>
      <div
        v-if="!message.client && message.dealt"
        :class="`messageRead ${
          message.client ? 'messageLeftStatus' : 'messageRightStatus'
        }`"
      >
        <EntityZ :entity="message.who" format="system" v-if="message.who" />
        read {{ message.dealt | formatDateTime }}
      </div>
      <div>
        <strong>by&#160;</strong>
        <EntityZ :entity="message.user" format="system" v-if="message.user" />-
        <span style="color: gray">{{
          message.timestamp | formatDateTime
        }}</span>
        - {{ message.origin }}
      </div>
      <span class="messageBody">{{ message.body }}</span>
      <div class="ajaxForm" v-if="message.client && !message.dealt">
        <template v-if="message.id != messageId">
          <strong>Reply message:</strong> enter
          <a @click="selectMessageForReply(message, false, false)">free text</a>
          or choose from a list of
          <a @click="selectMessageForReply(message, true, false)"
            >standard responses</a
          >
          or
          <a @click="dismissMessage(message)">dismiss message</a>
        </template>
        <FreeText
          v-if="message.id == messageId && !standardResponse"
          @create="createMessage"
          @createResponse="createFileResponseNew"
          @reset="resetMessageForm"
        />
        <StandardResponse
          v-if="message.id == messageId && standardResponse"
          @create="createFileResponse"
          @reset="resetMessageForm"
        />
      </div>
    </div>
    <div class="ajaxForm" v-if="computedUnreplied == 0">
      <template v-if="adding == false">
        <strong>Send new message:</strong> enter
        <a @click="selectMessageForReply(null, false, true)">free text</a> or
        choose from a list of
        <a @click="selectMessageForReply(null, true, true)"
          >standard responses</a
        >
      </template>
      <FreeText
        v-if="adding == true && !standardResponse"
        @create="createMessage"
        @createResponse="createFileResponseNew"
        @reset="resetMessageForm"
      />
      <StandardResponse
        v-if="adding == true && standardResponse"
        @create="createFileResponse"
        @reset="resetMessageForm"
      />
    </div>
  </div>
</template>

<script>
import FILE_FILE_RESPONSES from "@/graphql/file/FileFileResponses";
import FILE_MESSAGES from "@/graphql/file/FileMessages";
import CREATE_FILE_FILE_RESPONSE from "@/graphql/file/CreateFileFileResponse";
import CREATE_FILE_FILE_RESPONSE_NEW from "@/graphql/file/CreateFileFileResponseNew";
import CREATE_FILE_MESSAGE from "@/graphql/file/CreateFileMessage";
import UPDATE_MESSAGE_DISMISS from "@/graphql/message/UpdateMessageDismiss";
import EntityZ from "@/components/link/EntityZ";
import FreeText from "@/components/file/messages/FreeText";
import SectionHeader from "@/components/file/SectionHeader";
import StandardResponse from "@/components/file/messages/StandardResponse";
export default {
  name: "Messages",
  apollo: {
    fileResponses: {
      query: FILE_FILE_RESPONSES,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      update: (data) => data.file.fileResponses,
      fetchPolicy: "cache-and-network"
    },
    messages: {
      query: FILE_MESSAGES,
      variables() {
        return {
          id: Number(this.$route.params.id)
        };
      },
      update: (data) => data.file.messages,
      fetchPolicy: "cache-and-network"
    }
  },
  components: {
    EntityZ,
    FreeText,
    SectionHeader,
    StandardResponse
  },
  props: ["departmentId", "swiftMove"],
  computed: {
    computedUnreplied() {
      return this.computedList
        ? this.computedList.filter((i) => !i.dealt && i.client)
        : 0;
    },
    computedCount() {
      return this.computedList ? this.computedList.length : 0;
    },
    computedList() {
      const value = this.computedMessages.concat(this.computedFileResponses);
      return value.sort(this.sortTimestamp);
    },
    computedMessages() {
      if (!this.messages) return [];
      return this.messages.map((m) => {
        const client = m.user && (m.user.typeid == 3 || m.user.typeid == 4);
        return {
          id: m.id,
          typeId: 0,
          user: m.user,
          origin: this.selectOrigin(m.origin),
          timestamp: m.timestamp,
          dealt: m.dealt,
          who: m.who,
          body: m.body,
          client
        };
      });
    },
    computedFileResponses() {
      if (!this.fileResponses) return [];
      return this.fileResponses.map((f) => {
        const client = f.user && (f.user.typeid == 3 || f.user.typeid == 4);
        return {
          id: f.id,
          typeId: 1,
          user: f.user,
          origin: this.selectOrigin(0),
          timestamp: f.timestamp,
          dealt: f.dealt,
          who: f.who,
          body: f.response ? f.response.body : undefined,
          client
        };
      });
    },
    downloadLink() {
      return `${process.env.VUE_APP_CT_URL}/cors/admin/file/files/${this.$route.params.id}/messages/download`;
    }
  },
  data() {
    return {
      messageId: null,
      standardResponse: false,
      adding: false
    };
  },
  methods: {
    selectMessageForReply(message, standardResponse, adding) {
      this.messageId = message ? message.id : null;
      this.standardResponse = standardResponse;
      this.adding = adding;
    },
    async dismissMessage(message) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: UPDATE_MESSAGE_DISMISS,
          variables: { id: message.id },
          refetchQueries: [
            {
              query: FILE_MESSAGES,
              variables: { id: Number(this.$route.params.id) }
            },
            {
              query: FILE_FILE_RESPONSES,
              variables: { id: Number(this.$route.params.id) }
            }
          ]
        });
      }
    },
    resetMessageForm() {
      this.messageId = null;
      this.standardResponse = false;
      this.adding = false;
    },
    async createMessage(messageNew) {
      await this.$apollo.mutate({
        mutation: CREATE_FILE_MESSAGE,
        variables: {
          id: Number(this.$route.params.id),
          messageid: this.messageId,
          body: messageNew.body
        },
        refetchQueries: [
          {
            query: FILE_MESSAGES,
            variables: { id: Number(this.$route.params.id) }
          },
          {
            query: FILE_FILE_RESPONSES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.resetMessageForm();
    },
    async createFileResponseNew(messageNew) {
      await this.$apollo.mutate({
        mutation: CREATE_FILE_FILE_RESPONSE_NEW,
        variables: {
          id: Number(this.$route.params.id),
          messageid: this.messageId,
          folderid: messageNew.folderId,
          body: messageNew.body
        },
        refetchQueries: [
          {
            query: FILE_MESSAGES,
            variables: { id: Number(this.$route.params.id) }
          },
          {
            query: FILE_FILE_RESPONSES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.resetMessageForm();
    },
    async createFileResponse(messageNew) {
      await this.$apollo.mutate({
        mutation: CREATE_FILE_FILE_RESPONSE,
        variables: {
          id: Number(this.$route.params.id),
          messageid: this.messageId,
          responseid: messageNew.responseId
        },
        refetchQueries: [
          {
            query: FILE_MESSAGES,
            variables: { id: Number(this.$route.params.id) }
          },
          {
            query: FILE_FILE_RESPONSES,
            variables: { id: Number(this.$route.params.id) }
          }
        ]
      });
      this.resetMessageForm();
    },
    selectOrigin(originId) {
      let origin = "Unknown";
      if (originId == 0) {
        origin = "Web";
      } else if (originId == 1) {
        origin = "Apple device";
      } else if (originId == 2) {
        origin = "Android device";
      }
      return origin;
    },
    sortTimestamp(a, b) {
      return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
    }
  }
};
</script>

<style>
.messageBox {
  padding: 5px;
  box-shadow: 3px 3px 6px 3px #ccc;
}

.messageLeft {
  margin: 10px 60px 10px 5px;
  background: #dddddd;
  background: -webkit-linear-gradient(#dddddd, white);
  background: -o-linear-gradient(#dddddd, white);
  background: -moz-linear-gradient(#dddddd, white);
  background: linear-gradient(#dddddd, white);
}

.messageRight {
  margin: 10px 5px 10px 60px;
  text-align: end;
  background: #ccffcc;
  background: -webkit-linear-gradient(#ccccff, #eeeeff);
  background: -o-linear-gradient(#ccccff, #eeeeff);
  background: -moz-linear-gradient(#ccccff, #eeeeff);
  background: linear-gradient(#ccccff, #eeeeff);
}

.messageLeftStatus {
  float: right;
}

.messageRightStatus {
  float: left;
}

.messageRead {
  font-size: 0.8em;
  color: green;
}

.messageUnread {
  font-size: 0.8em;
  color: red;
}

.messageBody {
  white-space: pre-wrap;
  padding: 5px;
  display: block;
}

.messageResponseBody {
  white-space: pre-wrap;
  padding: 5px;
  display: block;
}

.messageResponseOdd {
  background: white;
  color: gray;
}

.messageResponseEven {
  background: #dddddd;
  color: gray;
}
</style>
